import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GoSlice {
  deviceId: string;
  ticketVisible: boolean;
  deviceTableData: any;
  record: any;
  ticketList: any;
  ticketData: any;
  inspectModalVisible: boolean;
  inspectResult: any;
  inspectLoading: boolean;
  removeDeviceModalVisible: boolean;
  reportIssueModalVisible: boolean;
  centerPosition: any;
  isEdit: boolean;
}

const initialState: GoSlice = {
  deviceId: "",
  ticketVisible: false,
  deviceTableData: [],
  record: {},
  ticketList: [],
  ticketData: {},
  inspectModalVisible: false,
  inspectResult: {},
  inspectLoading: true,
  removeDeviceModalVisible: false,
  reportIssueModalVisible: false,
  centerPosition: [0, 0],
  isEdit: false,
};

const goSlice = createSlice({
  name: "goPage",
  initialState,
  reducers: {
    setDeviceId: (state, action: PayloadAction<string>) => {
      state.deviceId = action.payload;
    },
    setTicketVisible: (state, action: PayloadAction<boolean>) => {
      state.ticketVisible = action.payload;
    },
    setDeviceTableData: (state, action: PayloadAction<any>) => {
      state.deviceTableData = action.payload;
    },
    setRecord: (state, action: PayloadAction<any>) => {
      state.record = action.payload;
    },
    setTicketList: (state, action: PayloadAction<any>) => {
      state.ticketList = action.payload;
    },
    setTicketData: (state, action: PayloadAction<any>) => {
      state.ticketData = action.payload;
    },
    setInspectModalVisible: (state, action: PayloadAction<any>) => {
      state.inspectModalVisible = action.payload;
    },
    setInspectResult: (state, action: PayloadAction<any>) => {
      state.inspectResult = action.payload;
    },
    setInspectLoading: (state, action: PayloadAction<any>) => {
      state.inspectLoading = action.payload;
    },
    setRemoveDeviceModalVisible: (state, action: PayloadAction<any>) => {
      state.removeDeviceModalVisible = action.payload;
    },
    setReportIssueModalVisible: (state, action: PayloadAction<any>) => {
      state.reportIssueModalVisible = action.payload;
    },
    setCenterPosition: (state, action: PayloadAction<any>) => {
      state.centerPosition = action.payload;
    },
    setIsEdit: (state, action: PayloadAction<any>) => {
      state.isEdit = action.payload;
    },
  },
});

export const {
  setDeviceId,
  setTicketVisible,
  setDeviceTableData,
  setRecord,
  setTicketList,
  setTicketData,
  setInspectModalVisible,
  setInspectResult,
  setInspectLoading,
  setRemoveDeviceModalVisible,
  setReportIssueModalVisible,
  setCenterPosition,
  setIsEdit,
} = goSlice.actions;

export default goSlice;
